module.exports = "/virtual-football-league/img/amblems/right/logos/Barcelona.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Barcelona.png
// module id = 2159
// module chunks = 4